export default __webpack_public_path__ + "static/media/close.09ddbab6.svg";